import { AxiosResponse } from 'axios';

export type HttpRequest = {
  url: string;
  method: HttpMethod;
  body?: any;
  headers?: any;
  params?: any;
  responseType?: any;
};

export interface HttpClient<R> {
  request: (data: HttpRequest) => Promise<HttpResponse<R>>;
}

export type HttpMethod = 'post' | 'get' | 'put' | 'delete' | 'patch';

export enum HttpStatusCode {
  ok = 200,
  created = 201,
  accepted = 202,
  noContent = 204,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  conflict = 409,
  unprocessableEntity = 422,
  serverError = 500,
  badGateway = 502,
}

export type HttpResponse<T = any> = {
  statusCode: HttpStatusCode;
  body: T;
  headers?: AxiosResponse['headers'];
  errorCode?: string;
};
